// extracted by mini-css-extract-plugin
export default {"searchGroupWrap":"searchGroupWrap---ti0fp","filtersLabel":"filtersLabel---DGtmk"};